import type { Locale } from '../i18n/types.ts';

const EXPORT_LIST_LIMIT = 10;

const ROW_COUNT = new Intl.NumberFormat('en-US');

/** `12,345` — the progress count is grouped the same way in both catalogs. */
export function formatExportRowCount(rows: number): string {
  return ROW_COUNT.format(rows);
}

/**
 * Join a toast list. At most ten items, then the locale's "and N more".
 * Chinese uses the enumeration comma; English uses a comma-space.
 */
export function formatExportList(items: readonly string[], locale: Locale): string {
  const shown = items.slice(0, EXPORT_LIST_LIMIT);
  const extra = items.length - shown.length;
  if (locale === 'zh-CN') {
    const body = shown.join('、');
    return extra > 0 ? `${body}等 ${String(extra)} 个` : body;
  }
  const body = shown.join(', ');
  return extra > 0 ? `${body}, and ${String(extra)} more` : body;
}
